import type { ChunkEnvelope } from "./daily-transport"

// The slice of Daily's call object we need to push a message. Kept structural
// (not the full DailyCall type) so this stays unit-testable with a fake.
export interface DailyMessageSink {
  meetingState(): string
  sendAppMessage(data: ChunkEnvelope, to: string): void
}

// Builds the `send` function for a {@link DailyTransport} backed by a real Daily
// call object.
//
// Daily's `sendAppMessage` THROWS synchronously ("sendAppMessage() only
// supported after join.") unless the call is in the "joined-meeting" state —
// which it is NOT before the initial async join resolves, nor during a
// reconnect. LiveYjsProvider drives `broadcast()` synchronously from its
// constructor (the initial sync step) and from a 5s resync timer, so an
// unguarded send would throw straight out of a React effect and into the
// top-level ErrorBoundary ("Something went wrong"). The classroom render path
// mounts <LiveDocProvider> the moment a room URL + token exist, well before the
// peer has joined, so this fired on essentially every entry once the
// live_classroom_collab flag went to 100%.
//
// Guard on the current state and swallow the residual race (the call can leave
// "joined-meeting" between the check and the call). Dropping a sync message is
// safe: the periodic resync re-announces our state once the call is joined
// again, and the CRDT reconciles.
export function dailyAppMessageSend(daily: DailyMessageSink): (data: ChunkEnvelope) => void {
  return (data) => {
    if (daily.meetingState() !== "joined-meeting") return
    try {
      daily.sendAppMessage(data, "*")
    } catch {
      // Transient state flip between the guard and the send — the resync heals it.
    }
  }
}
